import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { memberPortfolioFigures, memberSummaryNarrative } from './memberSummaryData';
const MemberSummary: React.FC<{ text: string; stats: Record<string, unknown> }> = ({ text, stats }) => {
  const narrative = memberSummaryNarrative(text), figures = memberPortfolioFigures(stats);
  return <Box sx={{ overflowWrap: 'anywhere' }}>
    {figures && <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle1" gutterBottom>Legislative activity</Typography>
      <Box display="flex" gap={1} flexWrap="wrap">
        <Chip label={`Associated bills: ${figures.total}`} />
        <Chip label={`Sponsored: ${figures.sponsored}${figures.sponsoredShare === null ? '' : ` (${figures.sponsoredShare}%)`}`} />
        <Chip label={`Cosponsored: ${figures.cosponsored}${figures.cosponsoredShare === null ? '' : ` (${figures.cosponsoredShare}%)`}`} />
        {figures.bipartisan !== null && <Chip label={`Bipartisan: ${figures.bipartisan} of ${figures.evaluated} evaluated`} />}
      </Box>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
        Database snapshot at the summary date, covering up to 200 recent bills per role. Bipartisan means both Democratic and Republican sponsors or cosponsors are recorded.
      </Typography>
    </Box>}
    {narrative ? <ReactMarkdown skipHtml>{narrative}</ReactMarkdown> : <Typography color="text.secondary">
      The saved AI analysis is incomplete and cannot be displayed reliably. Consult the sponsored and cosponsored legislation below while it awaits a background update.
    </Typography>}
  </Box>;
};
export default MemberSummary;
